import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { apiPOST } from '../../utils/apiHelper';

const Support = () => {
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState(null); // 'success' | 'error' | null
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!message.trim()) return;

        setIsSubmitting(true);
        setStatus(null);

        const response = await apiPOST('/support', { message });

        setIsSubmitting(false);
        if (response?.status === 200) {
            setStatus('success');
            setMessage('');
        } else {
            setStatus('error');
        }
    };

    return (
        <div className="max-w-2xl mx-auto px-4 py-10">
            <button
                onClick={() => navigate(-1)}
                className="mb-6 text-sm text-green-600 hover:underline"
            >
                ← Back
            </button>
            <h1 className="text-2xl font-bold mb-2">Support</h1>
            <p className="text-sm text-gray-500 mb-6">
                Logged in as <span className="font-medium">{user?.email}</span> (ID: {user?.userId || user?.id})
            </p>

            <form onSubmit={handleSubmit}>
                <label className="block text-sm font-medium mb-2" htmlFor="support-message">
                    Describe your issue
                </label>
                <textarea
                    id="support-message"
                    className="w-full border border-gray-300 rounded p-3 text-sm min-h-[160px] focus:outline-none focus:ring-2 focus:ring-green-500"
                    placeholder="Please describe the issue you're experiencing..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    disabled={isSubmitting}
                />

                {status === 'success' && (
                    <div className="mt-3">
                        <p className="text-green-600 text-sm font-medium">
                            Your support request has been submitted. We'll be in touch soon.
                        </p>
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="mt-3 text-sm text-green-600 hover:underline"
                        >
                            ← Return to App
                        </button>
                    </div>
                )}
                {status === 'error' && (
                    <p className="mt-3 text-red-600 text-sm font-medium">
                        Something went wrong. Please try again.
                    </p>
                )}

                <button
                    type="submit"
                    disabled={isSubmitting || !message.trim()}
                    className="mt-4 bg-green-500 text-white text-sm font-bold px-6 py-2 rounded disabled:opacity-50"
                >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
            </form>
        </div>
    );
};

export default Support;
